import request from '@/utils/request'

// 查询社区活动列表
export function listCommunityGroupActivity(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区活动分页
export function pageCommunityGroupActivity(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区活动详细
export function getCommunityGroupActivity(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增社区活动
export function addCommunityGroupActivity(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/add',
    method: 'post',
    data: data
  })
}

// 修改社区活动
export function updateCommunityGroupActivity(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除社区活动
export function delCommunityGroupActivity(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/delete',
    method: 'post',
    data: data
  })
}
